import type { ReactElement } from 'react';

import { components } from 'react-select';
import type { OptionProps } from 'react-select';

import { useTheme } from 'styled-components';
import { OptionTypeBase } from '../types';

export function Option<OptionType extends OptionTypeBase>({
  children,
  isSelected,
  innerProps,
  ...rest
}: OptionProps<OptionType, boolean>): ReactElement {
  const {
    data,
    selectProps: { getOptionValue },
  } = rest;
  const { select } = useTheme();

  return (
    <components.Option
      {...rest}
      isSelected={isSelected}
      innerProps={
        {
          ...innerProps,
          'data-n3__select-option': getOptionValue(data),
        } as typeof innerProps
      }
    >
      <>
        <span>{children}</span>
        {isSelected ? select.OPTION_SELECTED_ICON : null}
      </>
    </components.Option>
  );
}
